import React from "react";
import { AlertCircle, RefreshCw, XCircle, Lock, ServerOff, WifiOff } from "lucide-react";

const ErrorMessage = ({ error, onRetry }) => {
  const getErrorConfig = (error) => {
    if (typeof error === "string") {
      return {
        icon: AlertCircle,
        title: "Erreur",
        message: error,
        color: "red"
      };
    }

    if (error.response) {
      switch (error.response.status) {
        case 400:
          return {
            icon: XCircle,
            title: "Requête invalide",
            message: "Veuillez vérifier votre question et réessayer.",
            color: "red"
          };
        case 401:
          return {
            icon: Lock,
            title: "Session expirée",
            message: "Votre session a expiré. Veuillez vous reconnecter.",
            color: "orange"
          };
        case 403:
          return {
            icon: Lock,
            title: "Accès refusé",
            message: "Vous n'avez pas les droits nécessaires pour consulter cette information.",
            color: "orange"
          };
        case 404:
          return {
            icon: ServerOff,
            title: "Service introuvable",
            message: "Le service de l'Assistant IA RH est temporairement indisponible.",
            color: "red"
          };
        case 422:
          return {
            icon: XCircle,
            title: "Données invalides",
            message: "Les données envoyées sont invalides. Veuillez réessayer.",
            color: "red"
          };
        case 500:
          return {
            icon: ServerOff,
            title: "Erreur interne",
            message: "Une erreur interne est survenue. Veuillez réessayer.",
            color: "red"
          };
        default:
          return {
            icon: AlertCircle,
            title: "Erreur",
            message: "Une erreur est survenue. Veuillez réessayer.",
            color: "red"
          };
      }
    }

    if (error.code === "ECONNABORTED" || error.message.includes("timeout")) {
      return {
        icon: WifiOff,
        title: "Délai dépassé",
        message: "La réponse prend plus de temps que prévu. Veuillez réessayer.",
        color: "orange"
      };
    }

    if (error.message.includes("Network Error")) {
      return {
        icon: WifiOff,
        title: "Erreur réseau",
        message: "Impossible de contacter le serveur. Vérifiez votre connexion.",
        color: "orange"
      };
    }

    return {
      icon: AlertCircle,
      title: "Erreur inattendue",
      message: "Une erreur inattendue est survenue.",
      color: "red"
    };
  };

  const config = getErrorConfig(error);
  const Icon = config.icon;
  
  const colorClasses = {
    red: {
      bg: "bg-red-50",
      border: "border-red-200",
      iconBg: "bg-red-100",
      iconColor: "text-red-600",
      title: "text-red-900",
      message: "text-red-700",
      button: "bg-red-600 hover:bg-red-700"
    },
    orange: {
      bg: "bg-orange-50",
      border: "border-orange-200",
      iconBg: "bg-orange-100",
      iconColor: "text-orange-600",
      title: "text-orange-900",
      message: "text-orange-700",
      button: "bg-orange-600 hover:bg-orange-700"
    }
  };

  const colors = colorClasses[config.color];

  return (
    <div className={`${colors.bg} ${colors.border} border rounded-2xl p-5 mb-6 animate-fade-in`}>
      <div className="flex items-start space-x-4">
        <div className={`flex-shrink-0 w-12 h-12 ${colors.iconBg} rounded-xl flex items-center justify-center`}>
          <Icon className={`w-6 h-6 ${colors.iconColor}`} />
        </div>
        <div className="flex-1">
          <h4 className={`font-semibold ${colors.title} mb-1`}>{config.title}</h4>
          <p className={`text-sm ${colors.message} mb-4`}>{config.message}</p>
          {onRetry && (
            <button
              onClick={onRetry}
              className={`flex items-center space-x-2 px-4 py-2 ${colors.button} text-white rounded-xl text-sm transition-all shadow-md hover:shadow-lg`}
            >
              <RefreshCw size={16} />
              <span>Réessayer</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorMessage;
